import {
  FiltroFirestore,
  OrdenacaoFirestore,
} from '@/app/api/firebase/query/route';

type RequestFirebaseProps = {
  colecao: string;
  filtros: FiltroFirestore[];
  ordenacao?: OrdenacaoFirestore;
  limit?: number;
  startAfter?: unknown;
};

export default async function requestFirebase<T>(
  body: RequestFirebaseProps,
): Promise<T> {
  const resposta = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL!}/api/firebase/query`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );

  if (!resposta.ok) {
    throw new Error(`Erro na API: ${resposta.status}`);
  }

  return resposta.json();
}
